import { PopupMessageBox } from "../../../../common/messageBox";
import { GameData } from "../../gamestate/gameData";
import { toggleBonusGameMode } from "../../inGameFunction";
import { setAllowedInputs } from "../../../../common/functions/Functions_General";
import { enablePlay } from "../../../../common/functions/Functions_GameBar";

export class replayMessageBox {
  private parent: PIXI.Container;
  private bonusGameEndMessage: PopupMessageBox;
  private size: Array<number>;
  private activeGameData: GameData;

  constructor(
    parent: PIXI.Container,
    size: Array<number>,
    activeGameData: GameData
  ) {
    this.parent = new PIXI.Container();
    parent.addChild(this.parent);
    this.bonusGameEndMessage;

    this.size = size;
    this.activeGameData = activeGameData;
    this.setup(parent);
  }

  private setup = (_parent: PIXI.Container): void => {
    this.parent.alpha = 0.5;
    // this.inTween.pingpong=true;

    this.bonusGameEndMessage = new PopupMessageBox(
      1,
      this.size,
      this.activeGameData
    );
    this.bonusGameEndMessage.setTint(0xffff00);
    this.bonusGameEndMessage.setHeadText(
      this.activeGameData.gameTextGeneral.congrats
    );
    this.bonusGameEndMessage.setBodyText("-");
    // this.bonusGameEndMessage.setChildOf(this.parent);
    this.bonusGameEndMessage.setLabel(
      0,
      this.activeGameData.gameTextGeneral.continue
    );
    this.bonusGameEndMessage.setButtons(0, this.close.bind(this));
    // this.close()  ;
    this.bonusGameEndMessage.setMessageBoxPosY(380);
  };

  public close = (): void => {
    this.activeGameData.mainGame.setWinlineHidden();
    this.activeGameData.newSergioWinANimation.stop();
    this.activeGameData.freeSpinMode.setMessageDisplay();
    this.parent.alpha = 0;
    this.bonusGameEndMessage.setMessageBoxVisibile(false);
    this.activeGameData.resetAllBtns(this.activeGameData);
    // console.log(4);
    enablePlay(true, this.activeGameData);
    this.activeGameData.isBonusMessageVisible = false;

    // if (this.messagetoDisplay == 1) {
    // 	let test=this.activeGameData.GameContext().usedInputAction==this.activeGameData.API_handler.getServerActionBonusSpin();
    // 	// console.log((this.activeGameData.betResponse.gameContext.contextData).usedInputAction, this.activeGameData.API_handler.getServerActionBonusSpin())
    // 	if(test)
    // 	{
    // 		updateBalance(this.activeGameData);
    // 	}

    // 	displayBonusGameInfosWindow(false, this.activeGameData);

    // }

    // if (this.messagetoDisplay == 2) {
    // 	replaceAllWithBonus(this.activeGameData, true);
    // 	this.activeGameData.bonusGameMode=true;
    // 	this.activeGameData.bonusGameModeStarted=true;

    // 	console.log("START BONUS GAME")

    // }
    // else {
    // 	this.activeGameData.bonusGameMode=false;
    // 	this.activeGameData.bonusGameModeStarted=false;
    // 	replaceAllWithBonus(this.activeGameData, false);
    // 	console.log("EXIT BONUS GAME")
    // 	this.activeGameData.mainGame.setBonusLeftVisible(false);

    // }

    toggleBonusGameMode(this.activeGameData);

    if (this.activeGameData.GameContext().bonus)
      this.activeGameData.mainGame.setWinlineHidden();
    setAllowedInputs(this.activeGameData);
    if (
      this.activeGameData.GameContext().bonus &&
      this.activeGameData.replayMode
    ) {
      // console.log("increment2")
      this.activeGameData.replay.incrementIndex();
      // console.log("INCREASEssssssss")
    }
  };

  public setNewText = (head: string, body: string): void => {
    this.bonusGameEndMessage.setHeadText(head);
    this.bonusGameEndMessage.setBodyText(body);
  };

  private displayMessageIn = (): void => {
    this.activeGameData.playable = false;
    // if (this.messagetoDisplay === 1) {

    enablePlay(false, this.activeGameData);
    this.activeGameData.isBonusMessageVisible = true;
    this.bonusGameEndMessage.setBodyText(
      this.activeGameData.gameTextGeneral.msgFS3 +
        " " +
        this.activeGameData.GameContext().gameRoundBalance.bonusSpins +
        " " +
        this.activeGameData.gameText.firespins +
        "!"
    );
    this.parent.alpha = 1;
    this.bonusGameEndMessage.setMessageBoxVisibile(true, 0); //make it interactive
    this.activeGameData.environment.checkBonusMusic();
    // this.chechBonusMusic();
    //     this.activeGameData.normalGameMusic.stop();
    // this.activeGameData.bonusGameMusic.stop();
    // this.activeGameData.bonusGameMusic.play("bonus");;

    this.activeGameData.mainGame.setBonusLeft(
      this.activeGameData.GameContext().gameRoundBalance.bonusSpins
    );
  };
  // private chechBonusMusic=():void=>
  // {
  //     let hasBonusSpins=this.activeGameData.GameContext().gameRoundBalance.bonusSpins>0;
  //     let hasBonusResult=this.activeGameData.GameContext().bonusGameResult!=undefined;
  //     if(hasBonusResult ||hasBonusSpins)
  //     {
  //         //--bonus game

  //         this.activeGameData.normalGameMusic.stop();
  //          this.activeGameData.bonusGameMusic.stop();
  //          this.activeGameData.bonusGameMusic.play("bonus");
  //          this.activeGameData.mainGame.setBonusLeftVisible(true)

  //     }
  //     else
  //     {
  //         // default game
  //         this.activeGameData.bonusGameMusic.stop();
  //         this.activeGameData.normalGameMusic.stop();
  //         this.activeGameData.normalGameMusic.play("music");
  //         this.activeGameData.mainGame.setBonusLeftVisible(false)
  //     }
  //     // console.log("ssssssssssssssssss")
  // }
  public getDisplayMessageIn = (): Function => {
    // console.log("MESSAGE BOX TO DISPLAY")
    return this.displayMessageIn;
  };

  public getAlpha() {
    // let i = this.parent.alpha ? true : false;
    return this.parent.alpha;
  }

  public getReplayMessageBoxObj = (): replayMessageBox => {
    return this;
  };
}
